import React from "react"
import cx from "clsx"

export interface SidebarItemProps {
  id: string
  label: string
  hasItems: boolean
  menuCollapsed: boolean
  isNew?: boolean
}

const SidebarItemLabel = ({
  id,
  label,
  hasItems,
  menuCollapsed,
  isNew = false
}: SidebarItemProps) => (
  <>
    <div
      className={cx(
        `mr-2 h-6 flex-shrink-0`,
        `group-data-[tier="0"]/link:w-6 group-data-[tier="1"]/link:w-6 group-data-[tier="2"]/link:w-0.5`
      )}
      aria-hidden="true"
    >
      <svg className="hidden w-full h-full rotate-0 group-aria-[controls]/link:block group-aria-expanded/link:rotate-180 md:group-data-[collapsed=true]/sidebar:-rotate-90">
        <use href="#sidebar-icon-chevron" />
      </svg>
    </div>

    <div
      className={cx(
        `flex flex-1 items-center py-1 px-2.5 -ml-2.5 md:group-data-[collapsed=true]/sidebar:-ml-1`,
        `group-[[aria-current=page]]/link:rounded-full group-[[aria-current=page]]/link:bg-gray-200`,
        `group-aria-[controls]/link:px-0 group-aria-[controls]/link:ml-0 md:group-data-[collapsed=true]/sidebar:group-aria-[controls]/link:ml-0`,
        {
          "md:px-1": !hasItems && menuCollapsed
        }
      )}
    >
      <div
        className={cx(
          `w-6 h-6 hidden place-items-center mr-2`,
          `group-data-[tier="0"]/link:grid md:group-data-[collapsed=true]/sidebar:mr-0`
        )}
      >
        <svg className="w-6 h-6">
          <use href={`#sidebar-icon-${id}`} />
        </svg>
      </div>

      <span className="md:group-data-[collapsed=true]/sidebar:sr-only">
        {label}
      </span>
    </div>

    {isNew ? (
      <span className="-mr-1 ml-1.5 rounded border border-secondary-violet bg-secondary-violet-5 px-1 py-px text-[0.625rem] uppercase leading-normal text-secondary-violet md:ml-[0.3125rem] md:group-data-[collapsed=true]/sidebar:sr-only">
        New
      </span>
    ) : null}
  </>
)

export default SidebarItemLabel
